import React, { useEffect } from "react";
import "../../Assets/Styles/pages/landingRedesign.scss";
import "../../Assets/Styles/pages/pricingPageRedesign.scss";
import Nav from "../../Components/LandingComponents/Nav";
import Terms from "../../Components/TermsComponents/terms";
import usePageMetadata from "../../Utils/usePageMetadata";
import { useTranslation } from "react-i18next";

const TermsCondition: React.FC = () => {
	const { t } = useTranslation();

	usePageMetadata(
		"Terms & Conditions - eZy WaterMark",
		"Read the Terms of Service for eZy Watermark app. Learn about user accounts, community guidelines, billing & subscription conditions, and liabilities."
	);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<div className="landing-redesign">
			<Nav />
			<section className="pp-hero lr-grain">
				<div className="pp-hero__orbs">
					<div className="pp-hero__orb pp-hero__orb--1" />
					<div className="pp-hero__orb pp-hero__orb--2" />
				</div>

				<div className="pp-hero__content">
					<span className="pp-hero__badge">
						<span />
						{t("TermsTitle")}
					</span>
					<h1 className="pp-hero__title">
						<span className="lr-hero-word" style={{ animationDelay: "0.05s" }}>
							<span className="lr-text-gradient">Terms &</span>
						</span>{" "}
						<span className="lr-hero-word" style={{ animationDelay: "0.2s" }}>
							<span className="lr-text-gradient">Conditions</span>
						</span>
					</h1>
					<p className="pp-hero__subtitle">Please read these terms carefully before using our service.</p>
				</div>
			</section>
			<Terms />
		</div>
	);
};

export default TermsCondition;
